module.exports = __webpack_public_path__ + "img/poster.823d5890.png";